import { testimonials } from '@/mocks/dramas';

export default function Testimonials() {
  return (
    <section id="about" className="scroll-mt-20 bg-[#f3ecdf]/50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto mb-10 max-w-2xl text-center">
          <p className="mb-2 text-xs font-bold uppercase tracking-widest text-[#e85d3f]">网友口碑 · 追更党的选择</p>
          <h2 className="font-serif-sc text-2xl font-black text-[#26201a] md:text-3xl">追更党的真心话</h2>
          <p className="mt-3 text-sm leading-7 text-[#6f655a]">
            从「每晚蹲点」到「有条不紊地追更」，越来越多剧友把这里当成了自己的追剧小助手。
          </p>
        </div>

        <div className="grid gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure key={t.name} className="flex flex-col rounded-2xl border border-[#26201a]/8 bg-white p-6">
              <div className="mb-3 flex items-center gap-0.5 text-[#e8a33d]">
                {Array.from({ length: t.score }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="flex-1 text-sm leading-7 text-[#4b443c]">“{t.text}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-[#26201a]/8 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#e85d3f]/10 text-base font-bold text-[#e85d3f]">
                  {t.name.slice(0, 1)}
                </span>
                <div>
                  <p className="text-sm font-bold text-[#26201a]">{t.name}</p>
                  <p className="text-[11px] text-[#a3988a]">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}